module.exports = __webpack_public_path__ + "img/img-box-about-hello-right.561b803f.png";